// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperTitle-cls1_fHf","cls2":"PaperTitle-cls2_1jy PaperTitle-cls1_fHf"};